/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'confluence-analytics-chart.default-loading-text': '正在刷新分析数据...',
  'confluence-analytics-chart.tooltip.no-views-data': '无数据',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, other {{count} 次查看}}',
  'confluence-analytics-chart.tooltip.views-today-so-far': '{count, plural, other {到目前为止共 {count} 次查看}}',
  'confuence-analytics-chart.accessible-table.caption': '页面浏览量',
  'confuence-analytics-chart.accessible-table.header.date': '日期',
  'confuence-analytics-chart.accessible-table.header.view-count': '查看次数',
  'confuence-analytics-chart.accessible-table.no-view-count-data': '无查看次数',
};
